import styled from 'styled-components';

export const MainWrapper = styled.div`
  display: flex;
  padding: 35px 0;
  width: 100%;

  > div {
    flex-grow: 1;
  }

  @media (max-width: 767px) {
    padding: 23px 0;
  }
`;
